import { render, staticRenderFns } from "./sheet-cards.component.vue?vue&type=template&id=1f1cb030&scoped=true&"
import script from "./sheet-cards.component.vue?vue&type=script&lang=ts&"
export * from "./sheet-cards.component.vue?vue&type=script&lang=ts&"
import style0 from "./sheet-cards.component.vue?vue&type=style&index=0&id=1f1cb030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cb030",
  null
  
)

export default component.exports